<template>
  <div class="hello">
    <h1 :class="{'hide' : picking !== false}">{{ msg }}</h1>
    

    <Sticks :sticks="sticks" :choice="pick" :picking="picking" :key="stickKey" @picked="picking=true" :cup="cup" @remove="remove" />


    <transition name="fade" mode="out-in" >
    <div v-if="picking === false" :key="1">
    
          <div class="buttons">
            <button class="addstick" v-on:click="addstick">+ Add a stick</button>
            
            <button class="options-btn" @click="options=true">Options</button>
            <button class="reset" v-on:click="reset">Clear</button>

            <button class="update-btn" v-if="showUpdateBtn" @click="updateTemp">Update <b>{{ editName }}</b> preset</button>
            <transition name="update-status">
              <div class="update-status" v-if="showUpdateStatus">
                <p>'{{ editName }}' Has Been Updated!</p>
              </div>
            </transition>

            <button class="bigger pick-btn" v-on:click="pickstick(0)">Pick one!</button>

          </div>
          
          <Socials />

          <Modal :show="options" @close="options=false">
            <button class="add-to-templates" @click="addingTemplate=true; options=false;">Save as preset...</button>
              <button class="picktemplate" v-on:click="picktemplate(); options=false;">Manage presets...</button>
              <button class="addmultiple" v-on:click="addingmultiple = true; options=false;">Add multiple sticks...</button>
              <button class="resetpicked" v-on:click="resetpickedsticks(); options=false;" v-if="sticksAreOut">Reset picked sticks</button>
              <button class="btn cup-btn" @click="changeCup=true; options=false;">Change cup...</button>
              <button class="cancel" @click="options=false;">Close. Nevermind.</button>
          </Modal>
    
          <div class="help">
            <div v-show="help" class="helpbox">
              <ol>
                <li>Think of the things you need to make a decision about</li>
                <li>Write the things down on the sticks</li>
                <li>Click "Pick one!" to mix the sticks up and make a choice</li>
                <li>Click the little (X) on the right side of the stick to remove it</li>
                <li>Use the "Options" button to manage presets, add multiple sticks, or change your cup</li>
                <li>Pick a Stick was made for fun at <a href="https://www.minddevelopmentanddesign.com/" target="_blank" class="mind">MIND</a>!</li>
              </ol>
            </div>
            <button class="help" v-on:click="help = !help">
              <span v-if="!help">what's this?</span>
              <span v-else>ok, got it</span>
            </button>
          </div>
    
          <Modal :show="addingmultiple" @close="addingmultiple=false" :boxClasses="'addmultiplebox'">
            
            <h3>Enter each choice on a new line.</h3>
            <textarea v-model="multiplesticks"></textarea>
            <button v-on:click="addthemall">Add them all!</button>
            <button v-on:click="canceladding" class="cancel">Nevermind. Cancel.</button>
          
          </Modal>
    
          <Modal :show="pickingtemplate" @close="pickingtemplate=false" boxClasses="pickatemplate">
            <Templates v-on:cancel="cancelpickingtemplate" v-on:setsticks="setsticksfromtemplate" />
          </Modal>
    
          <Modal :show="changeCup" @close="changeCup=false">
            <CupPicker @cancel="changeCup=false" :current="cup" @getCup="setCup" @cancelCup="changeCup = false" />
          </Modal>

          <Modal :show="addingTemplate" @close="addingTemplate=false; newTemplateName=''" >
            
            <h2>New Preset's Name?</h2>
            <input type="text" name="newTempName" class="new-temp-name" v-model="newTemplateName">
            <button class="btn save-btn" @click="addToTemplates">Save</button>
            <button class="btn cancel" @click="addingTemplate=false; newTemplateName='';">Nevermind. Cancel.</button>
          
          </Modal>

        
      </div>

      <div v-if="picking === true" :key="2">
      <button class="bigger" @click="pickanother">Pick Another</button>
      <button class="bigger" v-on:click="goback">Go Back</button>
      </div>
    </transition>

  </div>
</template>

<script>
import Templates from './Templates.vue'
import Socials from './Socials.vue'
import Sticks from '@/components/Sticks'
import CupPicker from './CupPicker'
import Modal from './Modal'

export default {
  name: 'Main',
  components: {
    Templates,
    Sticks,
    CupPicker,
    Modal,
    Socials
  },  
  props: {
    msg: String
  },
  data: function() {
    return {
      sticks: [{choice:'', id: 1},{choice:'', id: 2},{choice:'', id:3}],
      pick: false,
      help: false,
      addingmultiple: false,
      multiplesticks: '',
      pickingtemplate: false,
      sticksAreOut: false,
      picking: false,
      stickKey: 0,
      addingTemplate: false,
      newTemplateName:'',
      changeCup: false,
      cup: 'cup',
      options: false,
      editID: null,
      editName: '',
      showUpdateBtn: false,
      showUpdateStatus: false
    }
  },
  methods: {
    addstick: function() {
      let current = new Date().getTime();
      this.sticks.push({choice:'', id: current});
    },
    pickstick: function(runCount) {
      //todo - this should only pick from the remaining unpicked sticks
      //if only one stick is left, maybe display a message or something
      this.picking = 'processing';
      this.sticks.forEach(function(stick, index) {
        if(stick.choice==''){stick.choice='Choice '+(index+1);}
      });
      const pick = Math.floor(Math.random() * this.sticks.length);

      if(this.sticks[pick].picked === true && runCount <= this.sticks.length){
        this.pickstick(runCount+1);
      }else if(this.sticks[pick].picked === true && runCount >= this.sticks.length){
        this.sticks.forEach(stick => {
          stick.picked = false;
        });
        this.pickstick(0);
      }else{
        this.pick = pick;
      }
    },
    addthemall: function() {
      //turn each line in the textarea into an array
      let ms = this.multiplesticks;
      let lines = ms.replace(/\r\n/g,"\n").split("\n").filter(line => line);
      //use a temporary array to save non-empty values from current sticks
      let tempsticks = [];
      this.sticks.forEach((stick) => {
        if(stick.choice != '') { tempsticks.push(stick.choice); }
      });
      //add any current sticks to the new ones being added
      let allLines = tempsticks.concat(lines);
      //now clear the sticks and set them to these
      this.sticks = [];
      let i = 0;
      allLines.forEach((line) => {
        this.sticks.push({choice:line, id: i});
        i++
      });
      //make sure there are at least three choices
      if(this.sticks.length === 0) this.reset();
      this.canceladding();
    },
    canceladding: function() {
      this.addingmultiple = false;
      this.multiplesticks = '';
    },
    picktemplate: function() {
      this.pickingtemplate = true;
    },
    cancelpickingtemplate: function() {
      this.pickingtemplate = false;
    },
    setsticksfromtemplate: function(choices) {
      this.sticksAreOut=false;
      this.sticks = [];
      this.editID = choices.editable === true ? choices.id : null
      this.editName = choices.title
      this.sticks = [...choices.choices]
      this.pickingtemplate = false;
    },
    pickanother: function() {
      this.sticks[this.pick].picked = true;
      
      this.sticksAreOut = true;
      this.picking = 'reset'
      setTimeout(() => {
        this.picking = false
        this.pick = false;
      }, 1000);
    },    
    goback: function() {
      this.picking = 'reset'
      setTimeout(() => {
        this.picking = false
        this.pick = false;
      }, 1000);
    },
    reset: function() {
      this.sticks = [{choice:'', id: 1},{choice:'', id: 2},{choice:'', id: 3}];
      this.editID = null
      this.editName = ''
    },
    remove: function(stickIndex) {
      this.sticks.splice(stickIndex, 1);
    },
    resetpickedsticks(){
      this.sticksAreOut = false;

      this.sticks.forEach(stick => {
        stick.picked = false
      });

      this.stickKey++
    },
    addToTemplates(){
      let sticksArr = []
      let id = new Date().getTime();
      this.sticks.forEach(stick => {
        sticksArr.push(stick)
      })
      let newTemp = {// eslint-disable-line 
        title: this.newTemplateName,
        choices: [...sticksArr],
        editable: true,
        id: id
      }; 
      let existingTemps = JSON.parse(localStorage.getItem("localTemplates"))
      if(existingTemps == null) existingTemps = []
      existingTemps.push(newTemp);
      localStorage.setItem("localTemplates", JSON.stringify(existingTemps))
      
      this.addingTemplate = false
      this.newTemplateName = ''
    },
    setCup(cup){
      this.cup = cup;
      this.changeCup = false
      localStorage.setItem('cup', cup)
    },
    updateTemp(){
      let tempArr = JSON.parse(localStorage.getItem('localTemplates'))
      let objIndex = tempArr.findIndex(temp => temp.id === this.editID)

      //if something happens where they deleted the template and try to update it, make a new template
      if(objIndex === -1) { 
        let newId = new Date().getTime();
        tempArr.push({
          editable: true,
          id: newId,
          title: this.editName,
          choices: [...this.sticks],
        });
        this.editID = newId;
      } else {
        tempArr[objIndex].choices = [];
        tempArr[objIndex].choices = [...this.sticks];
      }
      localStorage.setItem('localTemplates', JSON.stringify(tempArr))
      this.showUpdateBtn = false;
      this.showUpdateStatus = true;
      setTimeout(() => {
        this.showUpdateStatus = false;
      }, 3000);
    },
  },
  watch:{
    sticks: {
      handler: function () {
        if(this.editID !== null){
          let ls = JSON.parse(localStorage.getItem('localTemplates'));
          let thisTemp = JSON.stringify(ls[ls.findIndex(temp => temp.id === this.editID)].choices);
          if(thisTemp !== JSON.stringify(this.sticks)){
            this.showUpdateBtn = true;
          }else{
            console.log( `fake shit` )
            this.showUpdateBtn = false;
          }
        }
      },
      deep: true
    }
  },
  mounted() {
    let cup = localStorage.getItem('cup')
    if(cup == null) cup = 'cup'
    this.cup = cup

    //set initial templates if they haven't been set before
    let beenHereBefore = localStorage.getItem('pickastick');
    if(beenHereBefore == null) {
      
      let existingTemps = JSON.parse(localStorage.getItem("localTemplates"));
      if(existingTemps == null) existingTemps = [];

      let defaultTemps = [
        {
          title: "Chores",
          choices: [
            { choice: "Put things away", id: 1 },
            { choice: "Do the laundry", id: 2 },
            { choice: "Wash the dishes", id: 3 },
            { choice: "Dust & Vacuum", id: 4 },
            { choice: "Sweep & Mop", id: 5 },
            { choice: "Water the plants", id: 6 },
            { choice: "Feed the pets", id: 7 },
            { choice: "Take out the trash", id: 8 },
          ],
          editable: true,
          id: 'pickastickchores'
        },
        {
          title: "Colors",
          choices: [
            { choice: "Red", id: 9 },
            { choice: "Green", id: 10 },
            { choice: "Brown", id: 11 },
            { choice: "Blue", id: 12 },
            { choice: "Orange", id: 13 },
            { choice: "Yellow", id: 14 },
            { choice: "Purple", id: 15 },
            { choice: "Black", id: 16 },
            { choice: "White", id: 17 },
          ],
          editable: true,
          id: 'pickastickcolors'
        },
        {
          title: "Dinners",
          choices: [
            { choice: "Pizza", id: 18 },
            { choice: "Bacon cheeseburgers", id: 19 },
            { choice: "Quesadillas", id: 20 },
            { choice: "Tacos", id: 21 },
            { choice: "Sandwiches", id: 22 },
            { choice: "Soup & Salad", id: 23 },
            { choice: "Chinese Food", id: 24 },
            { choice: "Fish/Seafood", id: 25 },
            { choice: "Steak", id: 26 },
            { choice: "Chicken", id: 27 },
          ],
          editable: true,
          id: 'pickastickdindins'
        },
        {
          title: "Cheese",
          choices: [
            { choice: "Mozzarella", id: 28 },
            { choice: "Cheddar", id: 29 },
            { choice: "Monterey Jack", id: 30 },
            { choice: "Colby", id: 31 },
            { choice: "Gouda", id: 32 },
            { choice: "Muenster", id: 33 },
            { choice: "Swiss", id: 34 },
            { choice: "Brie", id: 35 },
            { choice: "Provolone", id: 36 },
            { choice: "Feta", id: 37 },
            { choice: "Ricotta", id: 38 },
          ],
          editable: true,
          id: 'pickastickcheese'
        },
      ];

      defaultTemps.push(...existingTemps);

      localStorage.setItem("localTemplates", JSON.stringify(defaultTemps));
      localStorage.setItem('pickastick', true);
    }


  },
}
</script>

<style lang="scss">
$font: 'Gaegu', cursive, sans-serif;

.foobar{
  width: 325px;
  margin: 10px auto;

  .foo{
    background: #89f7e2;
    margin: 10px 0;
    border-radius: 10px;
    padding: 10px;
  }
}


h1 {
  font: normal 28px $font;
  text-decoration: underline;
  transition: opacity 500ms;

  &.hide{
    opacity: 0;
  }
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
ul li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.buttons{
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas: 'add add' 'opt clear' 'update update' 'pick pick';
  max-width: 320px;
  margin: 0 auto;
  grid-gap: 1em;

  button{
    width: 100%;
    margin: 0;
  }

  .addstick{
    grid-area: add;
    height:44px;
    margin:0 auto;
    padding:2px 30px 2px 10px;
    background: linear-gradient(rgba(255,255,255,0.5), rgba(255,255,255,0.5)), transparent url('../assets/stick1.jpg') no-repeat center center;
    background-size: contain;
    border-radius:20px;
    display: flex;
    align-items: center;
    border: none;
    font-size: 24px;
    font-weight: bold;
    transition: all 250ms;

    &:hover{
      transform: scale(1.1);
    }
  }

  .options-btn{
    grid-area: opt;
  }

  .reset{
    grid-area: clear;
  }

  .pick-btn{
    grid-area: pick;
    margin: 0;
    width: 100%;
    border-radius: 8px;
    padding: 10px;
    background: #cfc;
    font-weight: bold;
  }

  .update-btn{
    grid-area: update;
    background: #fec;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .update-status{
    border-left: #cfc 3px solid;
    background: rgba(#cfc, .7);
    color: #000;
    border-radius: 5px;
    grid-column: span 2;
  }
}

button {
  margin:10px auto;
  padding:1px 10px;
  background:#ffc;
  border:solid 1px #000;
  border-radius: 16px;
  color:#333;
  width: 260px;
  text-align: center;
  display: block;
  cursor: pointer;
  font: normal 18px/20px 'Gaegu', cursive, sans-serif;
  box-shadow: 0 1px 2px rgba(0,0,0,0.3);
  transition: all 250ms;
  &.bigger { 
    width: 200px;
    margin-top: 30px;
    border-radius: 8px;
    padding: 10px; 
    background: #cfc;
    font-weight: bold;
    &:hover { transform: scale(1.1,1.1); }
  }
  &.help {
    text-decoration: underline;
    box-shadow: none;
    border: none;
    background: transparent;
    color: #008;
  }
  &.cancel { background: #ddd; }
  &.reset { background: #fcc; }
}

::-webkit-input-placeholder,
::-moz-placeholder,
:-ms-input-placeholder,
:-moz-placeholder,
::placeholder {
  color: rgba(0,0,0,0.5);
}
.helpbox {
  padding: 10px;
  max-width: 360px;
  text-align: left;
  margin: 0 auto;
}

.addmultiplebox textarea {
  width: 100%;
  height: 100px;
  margin: 10px 0;
}

.new-temp-name{
  width: 260px;
  border-radius: 45px;
  padding: 5px 10px;
  font-size: 1.5rem;
  font-family: $font;
  text-align: center;
  border: solid 2px #000;
}

.fade-enter-active, .fade-leave-active {
  transition: all 500ms;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.mind {
  color: #333;
  font: bold 12px monospace;
  text-decoration: underline;
}

.update-status-leave-active {
  transition: all 250ms;
  overflow: hidden;
}
.update-status-leave-to {
  transform: scale(0);
}

</style>
